module.exports = __webpack_public_path__ + "img/vission.e7d738c4.png";